import React from 'react'
import { ParticipantsList } from './list/page'

export const NewYear2026ParticipantsPage = () => {
  return <ParticipantsList />
}
